export const titleCase = (phrase) => {
  if (!phrase) return "";
  return phrase
    .split(" ")
    .map(
      (token) => token.charAt(0).toUpperCase() + token.substr(1).toLowerCase()
    )
    .join(" ");
};
